
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Définition approfondie du Personal-Branding : Développez votre marque personnelle",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez la signification de Définition personal-branding, un concept clé pour vous démarquer professionnellement et atteindre vos objectifs de carrière.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Définition approfondie du Personal-Branding : Développez votre marque personnelle",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez la signification de Définition personal-branding, un concept clé pour vous démarquer professionnellement et atteindre vos objectifs de carrière.",
        },
      ],
    };
  },
};
